import { useAppSelector } from '../../store/hooks';
import { useIsDev } from './useIsDev';

export const useIsEviTenant = () => {
  const { tenantAndProject } = useAppSelector(({ endUser }) => endUser);

  const isDev = useIsDev();

  return tenantAndProject?.subDomain === 'evi-hildesheim' || isDev;
};
